import React from 'react';
import ReactDOM from 'react-dom';
import '@atresmedia/elections_modules_library/dist/scss/main.scss';
import App from './App';
import './index.scss';

const host = window.location.hostname;

window.atresmedia_elecciones = (element, path) => {
  ReactDOM.render(<App entry={path} />, element);
};

if (
  window.parent !== window ||
  window.location.hostname === "localhost" ||
  window.location.href.indexOf("tvmodules") !== -1 ||
  window.location.href.indexOf("generador") !== -1
) {

window.atresmedia_elecciones(document.getElementById('atresmedia-elecciones-root'), '');

/*} else if (window.location.href.indexOf("?testing") !== -1) {
  window.init(
    document.getElementById("root"),
    "" //window.location.pathname.replace("eleccionesGV/", "")
  );
}*/
}
window.__debug__ = true;
